




















import FeedbackComponent from '@/components/base/FeedbackComponent'
import {StoreNamespace} from '@/globals/StoreNamespaceGlobal'
import {ExportType} from '@payroll/grid-widget/src/models/ExportType'
import {GridColumn} from '@payroll/grid-widget/src/models/GridColumn'
import {BaseRequest, Utils} from '@payroll/optimus-common'
import {FieldType, SearchFieldModel} from '@payroll/search-results-widget/src/models/SearchField.model'
import Component from 'vue-class-component'
import {Prop} from "vue-property-decorator";
import {Action} from 'vuex-class'

@Component({})
export default class DepositsPanelComponent extends FeedbackComponent {

  @Action('getEmployerDeposits', StoreNamespace.CUSTOMER_SERVICE) getEmployerDeposits: any
  @Action('exportEmployerDeposits', StoreNamespace.CUSTOMER_SERVICE) exportEmployerDeposits: any
  @Action('getEmployerDepositSettings', StoreNamespace.CUSTOMER_SERVICE) getEmployerDepositSettings: any

  @Prop(Number) employerId!: number

  private searchFields: SearchFieldModel[] = []
  private columns: GridColumn[] = []
  private pageNumber: number = 0
  private mobile: boolean = Utils.isMobile()
  private ExportType = ExportType
  private employerDepositSettings: any;


  beforeMount() {
    this.getEmployerDepositSettings({requestorCallback: this})
  }

  mounted() {
    if (Utils.isMobile()) {
      this.initMobileColumns()
    } else {
      this.initColumns()
    }
  }

  initSearchField() {
    let fullYear = new Date().getFullYear();

    this.searchFields.push({
      label: 'from_deposit-date',
      property: 'depositDateFrom',
      fieldType: FieldType.DATE_FIELD,
      monthOnly: true,
      initialSelected: new Date(fullYear, 0, 1)
    })
    this.searchFields.push({
      label: 'to_deposit-date',
      property: 'depositDateTo',
      fieldType: FieldType.DATE_FIELD,
      monthOnly: true
    })
    this.searchFields.push({
      label: 'employee-name',
      property: 'employeeName',
      fieldType: FieldType.TEXT_FIELD,
      maxLength: 100
    })
    this.searchFields.push({
      label: 'id_number',
      property: 'idNumber',
      fieldType: FieldType.TEXT_FIELD,
      maxLength: 16,
      advancedOnly: true
    })

    if(this.employerDepositSettings.showFundNum) {
      this.searchFields.push({
        label: 'the_fund_name',
        property: 'fundName',
        fieldType: FieldType.TEXT_FIELD,
        maxLength: 100,
        advancedOnly: true
      })
    }

    this.searchFields.push({
      label: 'input_compatible_with_report',
      property: 'compatibleFlag',
      fieldType: FieldType.SELECT_FIELD,
      selectOptions: [{
        value: 'false',
        description: '' + this.$t('no')
      }, {
        value: 'true',
        description: '' + this.$t('yes')
      }],
      selectDisplay: 'description',
      unSelectFirst: true,
      advancedOnly: true
    })
  }

  initColumns() {
    this.columns.push({
      property: 'memberFullName',
      header: 'employee-name',
      backgroundClass: ' header bg-light normal text-dark'
    } as GridColumn)
    this.columns.push({
      property: 'memberIdNum',
      header: 'identification_number',
      backgroundClass: ' header bg-light normal text-dark'
    } as GridColumn)
    this.columns.push({
      property: 'fundName',
      header: 'the_fund_name',
      backgroundClass: ' header bg-light normal text-dark'
    } as GridColumn)
    this.columns.push({
      property: 'financeCode',
      header: 'finance_code',
      backgroundClass: ' header bg-light normal text-dark'
    } as GridColumn)
    this.columns.push({
      property: 'depositDate',
      header: 'deposit-date',
      backgroundClass: ' header bg-light normal text-dark'
    } as GridColumn)
    this.columns.push({
      property: 'salaryDate',
      header: 'for_salary_date',
      borderLeft: true,
      backgroundClass: ' header bg-light normal text-dark'
    } as GridColumn)
    this.columns.push({
      property: 'reportedMember',
      header: 'employee-payments',
      backgroundClass: ' text-center primary-bg-color'
    } as GridColumn)
    this.columns.push({
      property: 'reportedEmployer',
      header: 'employer-payments',
      backgroundClass: ' text-center primary-bg-color'
    } as GridColumn)
    this.columns.push({
      property: 'reportedCompensations',
      header: 'compensations',
      backgroundClass: ' text-center primary-bg-color'
    } as GridColumn)
    this.columns.push({
      property: 'reportedIpi',
      header: 'work-incapacity',
      backgroundClass: ' text-center primary-bg-color'
    } as GridColumn)
    this.columns.push({
      property: 'reportedOther',
      header: 'other',
      backgroundClass: ' text-center primary-bg-color'
    } as GridColumn)
    this.columns.push({
      property: 'inputMember',
      header: 'employee-payments',
      backgroundClass: ' text-center secondary-bg-color'
    } as GridColumn)
    this.columns.push({
      property: 'inputEmployer',
      header: 'employer-payments',
      backgroundClass: ' text-center secondary-bg-color'
    } as GridColumn)
    this.columns.push({
      property: 'inputCompensations',
      header: 'compensations',
      backgroundClass: ' text-center secondary-bg-color'
    } as GridColumn)
    this.columns.push({
      property: 'inputIpi',
      header: 'work-incapacity',
      backgroundClass: ' text-center secondary-bg-color'
    } as GridColumn)
    this.columns.push({
      property: 'inputOther',
      header: 'other',
      backgroundClass: ' text-center secondary-bg-color'
    } as GridColumn)
  }

  initMobileColumns() {
    this.columns.push({property: 'memberFullName', header: 'employee-name'} as GridColumn)
    this.columns.push({property: 'memberIdNum', header: 'identification_number'} as GridColumn)
    this.columns.push({property: 'fundName', header: 'the_fund_name'} as GridColumn)
    this.columns.push({property: 'financeCode', header: 'finance_code'} as GridColumn)
    this.columns.push({property: 'depositDate', header: 'deposit-date'} as GridColumn)
    this.columns.push({property: 'salaryDate', header: 'salary_date'} as GridColumn)
    this.columns.push({property: 'reportedMember', header: 'reported-member'} as GridColumn)
    this.columns.push({property: 'reportedEmployer', header: 'reported-employer'} as GridColumn)
    this.columns.push({property: 'reportedCompensations', header: 'reported-compensation'} as GridColumn)
    this.columns.push({property: 'reportedIpi', header: 'reported-work-incapacity'} as GridColumn)
    this.columns.push({property: 'reportedOther', header: 'reported-other'} as GridColumn)
    this.columns.push({property: 'inputMember', header: 'input-member'} as GridColumn)
    this.columns.push({property: 'inputEmployer', header: 'input-employer'} as GridColumn)
    this.columns.push({property: 'inputCompensations', header: 'input-compensation'} as GridColumn)
    this.columns.push({property: 'inputIpi', header: 'input-work-incapacity'} as GridColumn)
    this.columns.push({property: 'inputOther', header: 'input-other'} as GridColumn)
    this.columns.push({property: 'isCompatible', header: 'input_compatible_with_report'} as GridColumn)
  }

  searchDeposits(searchObject: any) {
    this.pageNumber = searchObject.pageNumber
    searchObject.employerId = this.employerId

    this.getEmployerDeposits({
      requestBody: searchObject,
      requestorCallback: this
    })
  }

  onSuccess(data?: any, requestName?: any, message?: any) {
    if (requestName === "findMembersOrEmployersFor/getEmployerDeposits") {
      data.results.forEach((result: any) => {
        if (!Utils.isMobile()) {
          result._cellVariants = {
            reportedMember: 'primary-bg-color text-center sum-column',
            reportedEmployer: 'primary-bg-color text-center sum-column',
            reportedCompensations: 'primary-bg-color text-center sum-column',
            reportedIpi: 'primary-bg-color text-center sum-column',
            reportedOther: 'primary-bg-color text-center sum-column',
            inputMember: 'secondary-bg-color text-center sum-column',
            inputEmployer: 'secondary-bg-color text-center sum-column',
            inputCompensations: 'secondary-bg-color text-center sum-column',
            inputIpi: 'secondary-bg-color text-center sum-column',
            inputOther: 'secondary-bg-color text-center sum-column'
          }
        }
        result.tooltipMessage = '' + this.$t(result.differenceFlag ? 'difference_err_msg' : 'difference_success_msg')
      })
      this.$emit('successResults', data)
    } else if (requestName === "findMembersOrEmployersFor/exportEmployerDeposits") {
      this.$emit('successExport', data)
    } else if (requestName === "findMembersOrEmployersFor/getEmployerDepositSettings") {
      this.employerDepositSettings = data
      this.initSearchField()
    }
  }

  onExportClick(exportType: ExportType, gridColumns: Array<GridColumn>, searchObject: any): void {
    let exportColumns: GridColumn[] = []
    exportColumns.push({
      property: 'memberFullName',
      header: '' + this.$t('employee-name'),
      widthInPoints: 45
    } as GridColumn)
    exportColumns.push({
      property: 'memberIdNum',
      header: '' + this.$t('identification_number'),
      widthInPoints: 49
    } as GridColumn)
    exportColumns.push({
      property: 'fundName',
      header: '' + this.$t('the_fund_name'),
      widthInPoints: 60
    } as GridColumn)
    exportColumns.push({
      property: 'financeCode',
      header: '' + this.$t('finance_code'),
      widthInPoints: 30
    } as GridColumn)

    exportColumns.push({
      property: 'depositDate',
      header: '' + this.$t('deposit-date'),
      widthInPoints: 50
    } as GridColumn)
    exportColumns.push({
      property: 'salaryDate',
      header: '' + this.$t('for_salary_date'),
      widthInPoints: 40
    } as GridColumn)

    exportColumns.push({
      property: 'reportedMember',
      header: '' + this.$t('reported-member'),
      widthInPoints: 50
    } as GridColumn)
    exportColumns.push({
      property: 'reportedEmployer',
      header: '' + this.$t('reported-employer'),
      widthInPoints: 50
    } as GridColumn)
    exportColumns.push({
      property: 'reportedCompensations',
      header: '' + this.$t('reported-compensation'),
      widthInPoints: 50
    } as GridColumn)
    exportColumns.push({
      property: 'reportedIpi',
      header: '' + this.$t('reported-work-incapacity'),
      widthInPoints: 50
    } as GridColumn)
    exportColumns.push({
      property: 'reportedOther',
      header: '' + this.$t('reported-other'),
      widthInPoints: 50
    } as GridColumn)

    exportColumns.push({
      property: 'inputMember',
      header: '' + this.$t('input-member'),
      widthInPoints: 50
    } as GridColumn)
    exportColumns.push({
      property: 'inputEmployer',
      header: '' + this.$t('input-employer'),
      widthInPoints: 50
    } as GridColumn)
    exportColumns.push({
      property: 'inputCompensations',
      header: '' + this.$t('input-compensation'),
      widthInPoints: 50
    } as GridColumn)
    exportColumns.push({
      property: 'inputIpi',
      header: '' + this.$t('input-work-incapacity'),
      widthInPoints: 50
    } as GridColumn)
    exportColumns.push({
      property: 'inputOther',
      header: '' + this.$t('input-other'),
      widthInPoints: 50
    } as GridColumn)

    exportColumns.push({
      property: 'isCompatible',
      header: '' + this.$t('input_compatible_with_report'),
      widthInPoints: 30
    } as GridColumn)

    searchObject.employerId = this.employerId

    this.exportEmployerDeposits({
      requestBody: {
        headerText: this.exportFileName,
        exportType: exportType,
        columnsList: exportColumns,
        searchObject: searchObject
      } as BaseRequest,
      requestorCallback: this
    })
  }

  get exportFileName(): string {
    return '' + this.$t('deposit-grid-header')
  }
}

